export default __webpack_public_path__ + "6264387e3b87ceb72ea60e379f9aaf61.png";